import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';

export default function SprintHero({ 
    badgeText, 
    titlePrefix,
    highlightText,
    titleSuffix,
    subtitle, 
    subtitle2, 
    primaryButtonText, 
    secondaryButtonText, 
    secondaryHref, 
    metrics, 
    extraClasses = '' 
}) {
    const arrowSVG = (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ verticalAlign: 'middle'}}>
            <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );

    return (
        <section className={`sprint-hero ${extraClasses}`}>
            <Container>
                <Row className="align-items-center">
                    <Col lg={6} md={12}>
                        <div className="sprint-badge">
                            <span className="badge-dot"></span>
                            {badgeText}
                        </div>
                        <h1>
                            {titlePrefix} {highlightText && <span className="gradient-text">{highlightText}</span>} {titleSuffix}
                        </h1>
                        <p className="hero-sub">{subtitle}</p>
                        {subtitle2 && <p className="hero-sub-2">{subtitle2}</p>}
                        
                        <div className="sprint-hero-btns">
                            <Link to="/book-audit" className="sprint-btn-primary">
                                {primaryButtonText} {arrowSVG}
                            </Link>
                            {secondaryButtonText && secondaryHref && (
                                <a href={secondaryHref} className="sprint-btn-outline">
                                    {secondaryButtonText}
                                </a>
                            )}
                        </div>
                    </Col>
                    
                    <Col lg={6} md={12}>
                        <div className="sprint-hero-visual">
                            <div className="sprint-hero-metrics">
                                {metrics && metrics.map((m, idx) => (
                                    <div className="sprint-metric-card" key={idx}>
                                        <div className="metric-icon">{m.icon}</div>
                                        <div className="metric-value">{m.value}</div>
                                        <div className="metric-label">{m.label}</div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}
